// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"StepperButtons_buttonsWrapper__ZcrCQ","rightAligned":"StepperButtons_rightAligned__UQBD9"};